import {
  FAILED_GET_INVOICE,
  FAILED_PERSIST_INVOICE,
  RECEIVE_GET_INVOICE,
  RECEIVE_GET_INVOICES,
  RECEIVE_PERSIST_INVOICE,
  REQUEST_PERSIST_INVOICE,
} from 'common/redux/actions/invoice'
import { RESET_STATE } from 'common/redux/actions/global'

const initialState = {
  form: {
    data: null,
    error: '',
    fetching: true,
    sending: false,
    deleting: false,
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_INVOICE:
    case FAILED_PERSIST_INVOICE:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        },
      }
    case RECEIVE_PERSIST_INVOICE:
    case RECEIVE_GET_INVOICE:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        },
      }
    case RECEIVE_GET_INVOICES:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        },
      }
    case REQUEST_PERSIST_INVOICE:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true,
        },
      }

    case RESET_STATE:
      if (action.state === 'invoice') {
        return {
          ...state,
          [action.screen]: initialState[action.screen],
        }
      }

      return state
    default:
      return state
  }
}
